<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="MoveActor"
    title="Move Actor"
    submit-name="Move actor"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <p class="text-gray-700 mb-4">
      Moving an Actor A into another Actor B will move the entire structure of A
      inside B.
    </p>
    <img src="./images/examples/move.jpg" class="mx-auto mb-6 border" />
    <p v-if="selectedActor" class="Modal-intro mb-2">
      Select the Actor where
      <span :class="'text-' + selectedActor.color">{{
        selectedActor.name
      }}</span>
      will me moved:
    </p>
    <lm-actor-select
      v-if="selectedActor"
      ref="actorSelect"
      :selected-actor="selectedActor"
      allow-root
      disable-children
      check-rights
      show-placeholder
    />
  </form-modal>
</template>

<script>
import EventHub from '@/lib/eventHub'
import {mapGetters} from 'vuex'
import {AlertMessages, Events, Modal} from '@/lib/definitions'
import FormHelper from '@/components/form/formHelper'
import FormModal from '@/components/modals/FormModal'
import LmActorSelect from '@/components/form/LmActorSelect'

export default {
  name: 'ModalMoveActor',
  components: {
    LmActorSelect,
    FormModal
  },
  data() {
    return {
      Events,
      modalName: Modal.MOVE_ACTOR,
      modalRef: null,
      inputs: null,
      actorPathArr: null
    }
  },
  computed: mapGetters(['selectedActor', 'currentLandscape']),
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [this.$refs.actorSelect]
  },
  methods: {
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        this.$store
          .dispatch('moveActor', this.$refs.actorSelect.data)
          .then(actorPathArr => {
            this.actorPathArr = actorPathArr
            this.modalRef.submitSuccess()
          })
          .catch(error => this.modalRef.submitFails(error))
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        EventHub.emit(Events.SHOW_SNACKBAR, AlertMessages.ACTOR_MOVED)
        this.$router.push({
          name: 'info',
          params: {actor: this.actorPathArr}
        })
      }
    }
  }
}
</script>
